class LoadMoreButton extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('button');
      if (!this.btn ) return;

      this.btn.addEventListener('click', this.loadMore.bind(this));
    }
    updateURL(nextUrl) {
      if (!nextUrl) return;
      window.history.replaceState({ }, '', `${nextUrl}`);
    }

      loadMore(event) {
        event.preventDefault();

        const btn =event.target;

        btn.setAttribute('disabled', true);
        const nextUrl = btn.querySelector('[data-next-url]').value;
        this.updateURL(nextUrl);

        fetch(nextUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const id = 'ProductGridContainer';
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id).querySelector('.product-grid');
          const source = html.getElementById(id).querySelector('.product-grid');

          let items = source.querySelectorAll('.grid__item:not(.grid__item--loader):not(.card-description)');
          const newBtn = html.querySelector('load-more-button');
          if (source && destination) {
            for( let i = 0; i < items.length; i += 1 ) {
              const item = items[i];
              destination.appendChild(item)
            }
          }
          if(newBtn){
            this.parentNode.replaceChild(newBtn, this);
          }else {
            this.classList.add('hidden')
          }
      });
    }
  }
  customElements.define('load-more-button', LoadMoreButton);




  class LoadPrevPages extends HTMLElement {
    constructor() {
      super();
      const pages = parseInt(this.getAttribute('data-load-pages'),10);
      this.nextUrlBasic = `${window.location.pathname}${window.location.search}`
      for( let i = 1; i <= pages; i += 1 ) {
        this.loadPage(i)
      }
    }
    loadPage(pageNo) {
      const nextUrl = this.nextUrlBasic.replace(/page=[0-9]+/, 'page='+pageNo);
      fetch(nextUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const id = 'ProductGridContainer';
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id).querySelector('.product-grid');
        const source = html.getElementById(id).querySelector('.product-grid');
        let items = source.querySelectorAll('.grid__item:not(.grid__item--loader):not(.card-description)');
        if (source && destination) {
          for( let i = 0; i < items.length; i += 1 ) {
            const item = items[i];
            const fakeItem = destination.querySelector('.grid__item--loader-page-'+pageNo);
            fakeItem.parentNode.replaceChild(item, fakeItem);
          }
        }
      });
    }
  }
  customElements.define('load-prev-pages', LoadPrevPages);